import {
  ColourPicker,
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Switch from "components/Switch";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import {
  getWorkspaceBannerProperties,
  setWorkspaceBannerProperties,
} from "slices/systemAdmin/actions/systemAdmin";
import { htmlDecode } from "utils";

const BannerModal = ({ workspaceId }) => {
  const switchRef = useRef(null);
  const dispatch = useDispatch();

  const [enabled, setEnabled] = useState(false);
  const [message, setMessage] = useState("");
  const [background, setBackground] = useState("#434159");
  const [colour, setColour] = useState("#FFFFFF");
  const [isDirty, setIsDirty] = useState(false);

  //  Download banner info
  useEffect(() => {
    dispatch(getWorkspaceBannerProperties(workspaceId, dispatch)).then(
      (bannerProperties) => {
        setEnabled(bannerProperties.enabled);
        setMessage(htmlDecode(bannerProperties.message));
        setBackground(bannerProperties.background);
        setColour(bannerProperties.colour);
      }
    );
  }, [dispatch]);

  const handleSwitchChange = () => {
    setEnabled(!enabled);
    setIsDirty(true);
  };

  const handleMessageChange = ({ target: { value } }) => {
    setMessage(value);
    setIsDirty(true);
  };

  const handleBackgroundChange = (newBackground) => {
    setBackground(newBackground);
    setIsDirty(true);
  };

  const handleColorChange = (newColor) => {
    setColour(newColor);
    setIsDirty(true);
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.WORKSPACE_BANNER));
  };

  const handleSave = () => {
    dispatch(
      setWorkspaceBannerProperties(workspaceId, {
        enabled,
        message,
        background,
        colour,
      })
    );
    dispatch(hideModal(modalTypes.WORKSPACE_BANNER));
  };

  return (
    <Modal
      data-test="addUserModal"
      className="banner_popup fade-in"
      show
      onDismiss={handleCancel}
      backdrop
      centered
    >
      <Modal.Header>
        <b>Set Banner</b>
      </Modal.Header>
      <Modal.Body>
        <div className="banner_popup__container">
          <span className="banner_popup__container__field">
            <label htmlFor="enable_radio_switch" className="enabled">
              Turn Banner On/Off
            </label>
            <Switch
              id="enable_radio_switch"
              switchRef={switchRef}
              handleChange={handleSwitchChange}
              currentSwitchState={enabled}
            />
          </span>
          <span className="banner_popup__container__field full_width">
            <label
              htmlFor="banner_popup__container__message_field"
              className={`message ${!enabled ? "disabled" : ""}`}
            >
              Banner Message
            </label>
            <input
              id="banner_popup__container__message_field"
              type="text"
              className={`${!enabled ? "disabled" : ""}`}
              placeholder=""
              disabled={!enabled}
              value={message}
              onChange={handleMessageChange}
              data-clarity-mask="True"
            />
          </span>
          <span className="banner_popup__container__field">
            <label
              htmlFor="background-colour-button"
              className={`control_label ${!enabled ? "disabled" : ""}`}
            >
              Choose Banner Background Color
            </label>
            <ColourPicker
              disabled={!enabled}
              selectedColour={background}
              setSelectedColour={handleBackgroundChange}
            />
          </span>
          <span className="banner_popup__container__field">
            <label
              htmlFor="foreground-colour-button"
              className={`control_label ${!enabled ? "disabled" : ""}`}
            >
              Choose Banner Text Color
            </label>
            <ColourPicker
              disabled={!enabled}
              selectedColour={colour}
              setSelectedColour={handleColorChange}
            />
          </span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="saveButton"
          variant={NewButtonVariant.l1}
          onClick={handleSave}
          disabled={!isDirty || !message}
        >
          Save
        </NewButton>

        <NewButton
          data-testid="cancelButton"
          variant={NewButtonVariant.l2}
          onClick={handleCancel}
        >
          Cancel
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default BannerModal;

BannerModal.propTypes = {
  workspaceId: PropTypes.number,
};
